/**
 * A beléptető (ajtó) alkalmazás címe, ahogy a panel kiírja a szervezőnek (#86).
 *
 * MI VOLT A HIBA. A **Beléptető hozzáférések** fül eddig az admin saját
 * címéből vezette le a linket, egy port-cserével:
 * `window.location.origin.replace('3001', '3002')`. Ez csak azon az egyetlen
 * helyi gépen működik, ahol az admin tényleg a 3001-es porton fut. Domainen —
 * dev, stage és éles egyaránt — nincs mit cserélni, tehát a `replace` nem csinál
 * semmit, és a panel az ADMIN címét adja oda: `admin.easyevnts.com/check-in`.
 * Ott nincs ilyen útvonal, a szkenner a résztvevői appban él. A szervező egy
 * halott linket ad tovább az ajtósoknak, és ez az esemény reggelén derül ki,
 * sorban álló vendégek előtt.
 *
 * MIÉRT A `FRONTEND_URL` A FORRÁS, és miért nem új env-változó. A résztvevői
 * app címét a panel **már ismeri**, és három helyen használja is: az
 * esemény-előnézetnél (`Events.tsx`), a mágikus link mintájánál
 * (`Tickets.tsx`) és a tombola URL-jeinél (`RaffleSettings.tsx`). Ha ez a
 * negyedik link ugyanabból a forrásból jön, akkor nem tud elcsúszni azoktól,
 * amik ma bizonyítottan működnek. Egy új `VITE_PUBLIC_APP_URL` ehhez képest
 * csak egy második igazságot vezetne be, amit környezetenként külön kellene
 * karbantartani — és a `VITE_FRONTEND_URL` tartaléka (`admin.` prefix levágása)
 * mind a négy környezetben helyes választ ad már ma is.
 *
 * MIÉRT VAN NYELV A CÍMBEN. A belépőképernyő nem tudja magától, milyen nyelven
 * szóljon: az eseményt — és vele a nyelvet — csak a PIN beváltása UTÁN ismeri
 * meg. A nyelvet ezért a cím hordozza, nem az eszköz; ezt a döntést a
 * `frontend-node-nextjs-react/lib/checkinSession.ts` fejléce indokolja (egy
 * telefon, ami tegnap a holland ajtót vitte, ma nem adhat holland képernyőt egy
 * magyar eseményen). Ugyanott a `checkinHref(lang)` pontosan ezt a szabályt
 * kódolja: magyarnál NINCS paraméter, tehát a mai magyar események címe betű
 * szerint változatlan marad.
 */

/** A szkenner útvonala a résztvevői appban. */
export const CHECKIN_PATH = '/check-in';

/**
 * Az a nyelv, amit a belépőképernyő paraméter nélkül is felvesz. A `?lang=`
 * elhagyása nem rövidítés: a paraméter nélküli cím viselkedése ma is a magyar,
 * és a meglévő eseményeknek nem szabad új alakú linket kapniuk.
 */
const IMPLICIT_LANG = 'HU';

/**
 * A szervezőnek kiírt beléptető-cím.
 *
 * @param base a résztvevői app publikus címe (`FRONTEND_URL`)
 * @param language az esemény nyelve az `Event.language` alakjában (`HU`/`EN`/`SR`/`NL`)
 *
 * Az ismeretlen vagy hiányzó nyelv nem hibázik el semmit: a paramétert a
 * belépőképernyő `normalizeLang`-ja úgyis magyarra ejti, ha nem ismeri fel.
 * Ezért itt nincs fehérlista — egy ötödik esemény-nyelv magától jó linket kap,
 * ahelyett hogy némán elveszítené a paraméterét.
 */
export function checkinAppUrl(base: string, language?: string | null): string {
  // A záró perjel a `VITE_FRONTEND_URL`-ből jöhet; enélkül `//check-in` lenne.
  const origin = base.replace(/\/+$/, '');
  const lang = (language ?? '').trim();
  const query =
    lang === '' || lang.toUpperCase() === IMPLICIT_LANG ? '' : `?lang=${lang.toLowerCase()}`;
  return `${origin}${CHECKIN_PATH}${query}`;
}
